import React, {
  PropsWithChildren,
  useCallback,
  useMemo,
  useState,
} from "react";
import { createContext } from "react";
import {
  IElectionRound,
  ELECTION_STATUS,
  VOTING_ROUND_STATUS,
  ApiBallot,
  ISubmitStateMap,
  ISubmitState,
} from "../../domain/election";
import { Loading } from "../../components/loading";
import { IVoter } from "../../domain/voter";
import { computeInterfaceStatus, createSubmitStateMap, sortDisplayOrder } from "./util";
import { ElectionContext } from "./election.context";
import { ElectionProvider } from "./election.provider";
import { DEMO_VOTER } from "../../const/demo";
import { IBallotSubmission } from "../../domain/ballot-submission";

export enum INTERFACE_STATE {
  LOADING = "LOADING",
  VOTING_ALLOWED = "VOTING_ALLOWED",
  ALREADY_SUBMITTED = "ALREADY_SUBMITTED",
  ELECTION_NOT_YET_OPEN = "ELECTION_NOT_YET_OPEN",
  ELECTION_ALREADY_CLOSED = "ELECTION_ALREADY_CLOSED",
}



export interface SubmitResult {
  success: boolean;
  message?: string;
  code: string;
}

interface DemoElectionProviderProps extends PropsWithChildren {
  election: IElectionRound;
}
export const DemoElectionProvider = ({
  children,
  election,
}: DemoElectionProviderProps) => {

  const ballots = useMemo(() => {
    return election.ballots.sort((a, b) => sortDisplayOrder(a, b));
  }, [election]);

  const [submitStateMap, setSubmitStateMap] = useState<{
    [ballot_id: string]: ISubmitState;
  }>(createSubmitStateMap(election));

  const handlesubmitBallot = useCallback((ballotSubmission: IBallotSubmission) => {
    const { ballot_id } = ballotSubmission;
    return new Promise<any>(res => {
      setTimeout(() => {
        setSubmitStateMap(map => ({
          ...map,
          [ballot_id]: {
            self_submitted: true,
            proxy_submitted: true
          }
        }));

        res({
          status: 200
        } as any);
      }, 1000);
    });
  }, [setSubmitStateMap]);


  const interfaceState = useMemo(() => computeInterfaceStatus(election, DEMO_VOTER, submitStateMap), [election, submitStateMap]);
  return (
    <ElectionContext.Provider
      value={{
        election,
        ballots,
        submitStateMap,
        interfaceState,
        submitBallot: handlesubmitBallot,
        voter: DEMO_VOTER
      }}
    >
      {children}
    </ElectionContext.Provider>
  );
};
